angular.module('JV.FB.Service', [])
	.constant('JVConnectAppId', JV.FB_APPID || "")
	.service("Twitter", ['$http', '$window', function($http, $window) {
		this.connect = function(getTwitterOAuthUrl, successCallback) {
			$http.get(getTwitterOAuthUrl)
				.then(function(response){
					var twitter = window.open('https://api.twitter.com/oauth/authorize?force_login=true&oauth_token=' + response.data.token, 'Twitter', 'menubar=no,width=790,height=360,toolbar=no');
					$window.JVTwitterCallback = successCallback || angular.noop;
				});
		};
	}])
	.directive("jvFbPage", function() {
		return {
			scope: {
				FBPage: "=jvFbPage"
			},
			replace:true,
			template: "<div class=\"FBPage\"><img ng-src=\"{{FBPage.imageSrc}}\" alt=\"Avatar for {{FBPage.name}}\" />{{FBPage.platform | accountPrint}} - {{FBPage.name}}</div>"
		};
	});